import { atom } from '@exodus/headless-ui';
const DEFAULT_SLIPPAGE = 3;
const slippageAtom = atom((get, { selectors }) => {
    const remoteConfig = get(selectors.remoteConfig.data);
    return remoteConfig.infrastructure?.exchange?.defaultSlippage ?? DEFAULT_SLIPPAGE;
});
export default slippageAtom;
